<template>
  <div class="yxtbiz-signup-center pb24 bc-cCF5">
    <div class="flex space-between w1200 mt24 align-left">
      <div class="w100p bc-cCFF">
        <yxtf-tabs v-model="menusValue" class="pt24" type="pagetitle" @tab-click="searchPage">
          <yxtf-tab-pane v-for="(menu, index) in menus" :key="index" :label="menu.label" :disabled="pageLoading" :name="menu.value"></yxtf-tab-pane>
        </yxtf-tabs>
        <div class="bt1">
          <div class="pull-left ml16 mt20">
            <div class="signup_tabs">
              <yxtf-tabs v-model="appValue" :bottom-line="false" type="nounderline" @tab-click="appSelect">
                <yxtf-tab-pane 
                :label="app.label" 
                :name="app.value" 
                v-for="(app, index) in apps" 
                :key="index"
                ></yxtf-tab-pane>
              </yxtf-tabs>
            </div>
          </div>
          <div class="pull-right mr24 mt16 mb16 flex">
            <yxt-select
              v-model="statusValue"
              clearable
              class="w180 mr16"
              :placeholder="menusValue === '1' ? language().lbl_registration_status : language().lbl_audit_status"
              @change="searchPage"
            >
              <yxt-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </yxt-option>
            </yxt-select>
            <yxt-select
              v-model="timeTypesValue"
              clearable
              class="w180 mr16"
              :placeholder="language().lbl_start_time"
              @change="searchPage"
            >
              <yxt-option
                v-for="(item, index) in timeTypes"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </yxt-option>
            </yxt-select>
            <yxtf-input
              v-model="searchKey"
              class="w260"
              :placeholder="language().lbl_enter_name_search"
              searchable
              clearable
              :maxlength="255"
              @clear="searchPage"
              @search="searchPage"
            ></yxtf-input>
          </div>
        </div>
      </div>
    </div>
    <div class="w1200 mt24 align-left mh198" v-loading="pageLoading">
      <div v-for="(item, index) in data" :class="`relative w50p-12 bc-cCFF rtl4 rtr4 rbl4 rbr4 mb24 inline-block ${index % 2 === 1 ? 'ml24' : ''}`" :key="index">
        <div class="absolute fs12 right1 top1 h20 pl8 pr8 bc-cCF5" v-if="item.projectStatus !== 2">{{
          (
            $parent.signupStatusObj[item.projectStatus].func
            ? $parent.signupStatusObj[item.projectStatus].func(item.actualNum, item.maxQuota)
            : $parent.signupStatusObj[item.projectStatus].label
          ) || ''
        }}</div>
        <div class="flex pointer" @click.stop="toDetails(item)">
          <div class="relative mt28 ml24 mb28 d-img">
            <div v-show="item.grpMode ===1" class="align-center zindex1 absolute left4 top4 bc-cF0F6FF w40 h20 c-cC436BFF fs12 br2">共享</div>
            <yxtf-image class="d-img" :src="item.coverUrl" @error="item.coverUrl = '`${$staticBaseUrl}ufd/55a3e0/o2o/pc/other/project.png`'" fit="cover"></yxtf-image>
          </div>
          <div class="mt28 ml16 mr24 mb28">
            <div class="mb8 fw500 ellipsis lineClamp1 word-break-inherit" :title="item.projectName">{{item.projectName}}</div>
            <div class="mb8 c-cC8C">
              <yxtf-tag type="info" size="small">{{item.appName}}</yxtf-tag>
              <span>{{timeText(item.startTime, item.endTime, item.projectStatus)}}</span>
            </div>
            <div class="mb2" v-if="item.maxQuota">
              <yxtf-progress :percentage="toPercentage100(parseInt((item.actualNum || 0) / item.maxQuota * 100))">
                <span slot='content'>{{toPercentage100(parseInt((item.actualNum || 0) / item.maxQuota * 100))}}%（{{parseInt(item.actualNum / item.maxQuota) === 1 ? language().msg_full : (item.actualNum + '/' + item.maxQuota)}}）</span>
              </yxtf-progress>
            </div>
            <div :class="`fw500 ${
              {
                1: item.maxQuota ? '' : 'mt20',
                2: item.maxQuota ? '' : 'mt16'
              }[menusValue]
            } ${
              {
                1: item.pointPrice ? 'fs24 c-cCOrange pt4' : 'fs20 c-cC59 pt4',
                2: {
                  0: 'fs16 c-cCOrange pt8',
                  1: 'fs16 c-cC59 pt8',
                  2: 'fs16 c-cC59 pt8',
                  3: 'fs16 c-cCRed pt8',
                  4: 'fs16 c-cCRed pt8',
                  5: 'fs16 c-cC59 pt8'
                }[item.auditStatus] || ''
              }[menusValue]
            }`">
              <template v-if="menusValue === '1'">
                <template v-if="item.pointPrice">
                  <span class="mr4">{{item.pointPrice}}</span>
                  <span class="fw400 fs14 relative top-3">{{language().msg_integral}}</span>
                </template>
                <template v-else>
                  <span class="mr4">{{language().msg_free}}</span>
                </template>
              </template>
              <template v-else-if="menusValue === '2'">
                <template v-if="item.auditStatus">
                  <span>{{$parent.auditStatusObj[item.auditStatus].label || ''}}</span>
                  <span class="fw400 fs14" v-if="$parent.auditStatusObj[item.auditStatus].info">（{{ $parent.auditStatusObj[item.auditStatus].info || '' }}）</span>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <yxtf-empty v-if="!data.length" :empty-text="language().msg_empty" class="mv148">
        <!-- <div class="hand color-primary-6 font-size-14" @click="handelToPath">
          <span>{{language().btn_turn_around}}</span>
        </div> -->
      </yxtf-empty>
    </div>
    <div class="w100p w1200 mt24 center">
      <yxtf-pagination background layout="prev, pager, next" :current-page.sync="current" :total="total" :page-size="size" @current-change="search" style="margin: 0 auto;"></yxtf-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'YxtbizSignupCenter',
  inject: ['language'],
  data() {
    return {
      // 页面加载
      pageLoading: false,
      // 平台
      appValue: undefined,
      apps: [],
      // 菜单
      menusValue: '1',
      menus: [],
      // 状态
      signupValue: undefined,
      auditValue: undefined,
      // 时间
      timeTypesValue: undefined,
      timeTypes: [],
      // 搜索
      searchKey: '',
      // 数据
      data: [],
      total: 0,
      // 分页
      current: 1,
      size: 20
    };
  },
  computed: {
    // 状态组合
    statusValue: {
      get() {
        return this.menusValue === '1' ? this.signupValue : this.auditValue;
      },
      set(value) {
        this[this.menusValue === '1' ? 'signupValue' : 'auditValue'] = value;
      }
    },
    statusList() {
      return this.menusValue === '1'
        ? this.$parent.signupStatus.filter(_ => Object.keys(_).includes('value1')).map(_ => ({..._, value: _.value1}))
        : this.$parent.auditStatus.map(_ => ({
          ..._,
          label: _.label + (_.info ? `（${_.info}）` : '')
        }));
    }
  },
  methods: {
    // 随便转转
    handelToPath() {
      this.$emit('toPath');
    },
    // 超100 = 100
    toPercentage100(value) {
      return value > 100 ? 100 : value;
    },
    // 打开详情
    toDetails(row) {
      if (row.projectStatus !== 0 && row.projectStatus !== 1) {
        this.$emit('toDetails', row.id, row);
      }
    },
    // 时间显示生成
    timeText(startTime, endTime, projectStatus) {
      if (startTime && endTime) {
        if (projectStatus === 2 || projectStatus === 6 || projectStatus === 4) {
          return this.language().msg_deadline.replace('$time', moment(endTime).format('MM-DD HH:mm'));
        } else {
          return moment(startTime).format('MM-DD HH:mm') + ' ～ ' + moment(endTime).format('MM-DD HH:mm');
        }
      } else {
        return this.language().msg_long_term;
      }
    },
    // 平台选择
    appSelect() {
      // this.appValue = id;
      this.searchPage();
    },
    // 重置分页搜索
    searchPage() {
      this.current = 1;
      this.search();
    },
    // 触发搜索
    async search() {
      const SDK = this.$parent.SDK;
      this.pageLoading = true;
      // 获取报名项目列表
      const res = await SDK.getProjects({
        appIds: (this.appValue && this.appValue !== '0') ? [this.appValue] : [],
        searchType: this.menusValue,
        startTimeType: this.timeTypesValue,
        [this.menusValue === '1' ? 'projectStatus' : 'auditStatus']: this.statusValue,
        searchKey: this.searchKey,
        limit: this.size,
        offset: (this.current - 1) * this.size
      });
      this.$parent.fmessage(res);
      this.pageLoading = false;
      this.data = res.datas;
      this.total = res.paging.count;
      this.size = res.paging.limit;
    },
    // 获取报名中的数据
    async getSignuping() {
      const SDK = this.$parent.SDK;
      this.pageLoading = true;
      // 获取报名项目列表
      const res = await SDK.getProjects({
        appIds: (this.appValue && this.appValue !== '0') ? [this.appValue] : [],
        searchType: this.menusValue,
        startTimeType: this.timeTypesValue,
        projectStatus: 1,
        searchKey: this.searchKey,
        limit: this.size,
        offset: (this.current - 1) * this.size
      });
      this.$parent.fmessage(res);
      this.pageLoading = false;
      if (res && res.paging.count > 0 && this.menusValue === '1') {
        // 初始化查询项目列表--获取报名中的报名
        this.statusValue = 1;
      }
      this.searchPage();

    }
  },
  async created() {
    const SDK = this.$parent.SDK;
    const { signupMenus, signupApps, signupTimes } = SDK.getCodes('pc');
    // 获取报名菜单
    this.menus = [...signupMenus];
    // 获取平台列表
    const apps = await SDK.getApps();
    this.$parent.fmessage(apps);
    this.apps = [...signupApps, ...(apps.datas || []).map(_ => ({ value: _.id, label: _.appName }))];
    // 获取报名时间类型
    this.timeTypes = [...signupTimes];
    // 查询是否有报名中的报名
    this.getSignuping();
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-signup-center {
  display: flex;
  flex-direction: column;
  .d-img {
    width: 196px;
    height: 112px;
  }
  .signup_tabs{
    width:500px;
    ::v-deep .yxtf-tabs__nav-scrollBtn {
      width: 80px;
      padding-left: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    ::v-deep .yxtf-icon-arrow-left {
      padding-left: 16px;
      border-left: 1px solid #f0f0f0;
    }
    ::v-deep .yxtf-tabs__item{
      height: 32px;
      line-height:32px;
      padding:0 16px;
      font-weight: 400;
      color: #262626;
      border-radius: 4px;
      margin-right: 32px;
    }
    ::v-deep .yxtf-tabs__item.is-active{
      background: #F5F5F5;
      font-weight: 500;
      color: var(--color-primary);
    }
    ::v-deep .yxtf-tabs__item:hover{
      background: #F5F5F5;
    }
    ::v-deep .yxtf-tabs__nav-next, ::v-deep .yxtf-tabs__nav-prev{
      line-height:32px;
    }
  }
}
</style>
